
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight,faPhoneVolume } from '@fortawesome/free-solid-svg-icons';

function Footer() {
  return (
    <footer>
        

        
        <div class="tr-footer-area tr-footer-bg black-bg z-index-1" data-background="assets/img/home-01/shape/footer.png">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                        <div class="tr-footer-widget tr-footer-col-1-1">
                            <div class="tr-footer-logo">
                                <a href="#"><img src="assets/img/logo/logo footer.jpeg" alt=""/></a>
                            </div>
                            <div class="tr-footer-text">
                                <p class="mb-20">Taking India Global</p>
                                <div class="tr-footer-contact p-relative">
                                    <span class="tr-footer-contact-icon"><FontAwesomeIcon icon={faPhoneVolume} /></span>
                                    <a class="border-line-white" href="tel:+91 8238823767">+91 8238823767</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".5s">
                        <div class="tr-footer-widget tr-footer-col-1-2">
                            <div>
                                <h4 class="tr-footer-widget-title" style={{textAlign: "left"}}>Our Services</h4>
                                <div class="tr-footer-widget-menu">
                                    <ul style={{textAlign: "left"}}>
                                        <li><a href="/studentVisa" ><FontAwesomeIcon icon={faAngleRight} />Student Visa</a></li>
                                        <li><a href="/touristVisa"><FontAwesomeIcon icon={faAngleRight} />Tourist Visa </a></li>
                                        <li><a href="/ielts"><FontAwesomeIcon icon={faAngleRight} />IELTS</a></li>
                                        <li><a href="/doulingo"><FontAwesomeIcon icon={faAngleRight} />Duolingo</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".7s">
                        <div class="tr-footer-widget tr-footer-col-1-3">
                            <div>
                                <h4 class="tr-footer-widget-title" style={{textAlign: "left"}}>Useful Links</h4>
                                <div class="tr-footer-widget-menu">
                                    <ul style={{textAlign: "left"}}>
                                        <li><a href="/"><FontAwesomeIcon icon={faAngleRight} />Home</a></li>
                                        <li><a href="/about"><FontAwesomeIcon icon={faAngleRight} />About us</a></li>
                                        <li><a href="/studentVisa"><FontAwesomeIcon icon={faAngleRight} />Services</a></li>
                                        <li><a href="/usaVisa"><FontAwesomeIcon icon={faAngleRight} />Country</a></li>
                                        <li><a href="/ielts"><FontAwesomeIcon icon={faAngleRight} />Coaching</a></li>
                                        <li><a href="/contact"><FontAwesomeIcon icon={faAngleRight} />Contact</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".9s">
                        <div class="tr-footer-widget tr-footer-col-1-4">
                            <h4 class="tr-footer-widget-title" style={{textAlign: "left"}}>Useful Links</h4>
                            <div class="tr-footer-widget-post-wrap">
                                <ul>
                                    <li style={{textAlign: "left"}}>
                                        <div class="tr-footer-widget-post-item d-flex align-items-center">
                                            <div class="tr-footer-widget-post-thumb">
                                                <img src="assets/img/home-01/footer/thumb-sm-1.jpg" alt=""/>
                                            </div>
                                            <div class="tr-footer-widget-post-content">
                                                <span>
                                       <i class="fa-sharp fa-regular fa-calendar-days"></i>
                                       20 April, 2025
                                    </span>
                                                <h5><a class="border-line-white" href="/blog">Why Duolingo Is the Best Way to Learn English </a></h5>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{textAlign: "left"}}>
                                        <div class="tr-footer-widget-post-item d-flex align-items-center">
                                            <div class="tr-footer-widget-post-thumb">
                                                <img src="assets/img/home-01/footer/thumb-sm-2.jpg" alt=""/>
                                            </div>
                                            <div class="tr-footer-widget-post-content">
                                                <span>
                                       <i class="fa-sharp fa-regular fa-calendar-days"></i>
                                       25 April, 2025
                                    </span>
                                                <h5><a class="border-line-white" href="/blog">Your Duolingo English Test Score</a></h5>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        
        <div class="tr-copyright-area tr-copyright-ptb">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6 col-md-5">
                        <div class="tr-copyright-left text-center text-md-start wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                            <p>© 2025 All Rights Reserved <span>Apex Advisors</span></p>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-7"  style={{textAlign:"right"}}>
                        {/* <div class="tr-footer-social text-center text-md-end wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".5s"> */}
                           
                            <a href="/terms-and-conditions">  Terms And Conditions | Privacy Policy</a>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </div>
        

    </footer>
  );
}

export default Footer;